import { render, staticRenderFns } from "./PagosLista.vue?vue&type=template&id=dd3aac90&"
import script from "./PagosLista.vue?vue&type=script&lang=js&"
export * from "./PagosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports